import { useState } from 'react';
import { getWorkOrderData } from '../services/api';
import { generateWorkOrderPDF } from '../utils/pdfGenerator';

export const useWorkOrderPDF = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generatePDF = async (visitId: number | string) => {
    try {
      setIsGenerating(true);
      setError(null);

      const response = await getWorkOrderData(visitId);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'No se pudo obtener los datos de la orden de trabajo');
      }

      generateWorkOrderPDF(response.data);

      return response.data.sales?.order_id || null;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'No se pudo generar el PDF';
      setError(errorMessage);
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generatePDF,
    isGenerating,
    error,
  };
};
